// ThemeContext.tsx

import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { useLocalStorage } from 'usehooks-ts';

type ThemeType = 'light' | 'dark';
type ThemeContextType = {
  mode: ThemeType;
  toggleTheme: () => void;
};

// Provide a default that matches the type (won't be used in real app)
const ThemeModeContext = createContext<ThemeContextType>({
  mode: 'light',
  toggleTheme: () => {},
});

export const useThemeMode = () => useContext(ThemeModeContext);

export const CustomThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [mode, setMode] = useState<ThemeType>('light');
  const [localTheme] = useLocalStorage('theme', 'light');

  useEffect(() => {
    console.log('Theme:::', localTheme);
    if (localTheme) {
      setMode(localTheme as ThemeType);
    }
  }, [localTheme]);

  const toggleTheme = () => {
    setMode((prev) => (prev === 'light' ? 'dark' : 'light'));
  };

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
        },
      }),
    [mode],
  );

  return (
    <ThemeModeContext.Provider value={{ toggleTheme, mode }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeModeContext.Provider>
  );
};
